import useSWR from "swr";
import Spinner from "components/utilities/Spinner";
import { apiClientCommon } from "services/apiClientCommon";
import { useAppSelector } from "stores/hooks";
import { selectSearchQuery } from "stores/search/searchSlice";
import RequestRegionSection from "./RequestRegionSection";
const searchPropertiesCountFetcher = async ({
  url,
  ...params
}: {
  url: string;
} & Parameters<typeof apiClientCommon.getPropertiesCountGET>[0]["params"]) => {
  const newSearchData = await apiClientCommon.getPropertiesCountGET({
    params
  });
  return newSearchData.data.data.count;
};
const NotFound = () => {
  const searchQuery = useAppSelector(selectSearchQuery);
  const {
    data: propertyCount
  } = useSWR(searchQuery ? {
    url: `/api/search/count`,
    bounds: searchQuery.bounds,
    lat: searchQuery.lat,
    lng: searchQuery.lng,
    name: searchQuery.name,
    isMapDragged: searchQuery.mapDragged
  } : null,
  // to resolve multiple api call issue
  searchPropertiesCountFetcher, {
    loadingTimeout: 15000,
    revalidateOnFocus: false,
    dedupingInterval: 3000,
    errorRetryCount: 3
  });
  return propertyCount === null || propertyCount === undefined ? <div className='flex items-center justify-center px-4 py-16' data-sentry-component="NotFound" data-sentry-source-file="not-found.tsx">
      <Spinner data-sentry-element="Spinner" data-sentry-source-file="not-found.tsx" />
    </div> : <div className='px-4 pb-[60px] pt-6 md:px-6' data-sentry-component="NotFound" data-sentry-source-file="not-found.tsx">
      {propertyCount && propertyCount > 0 ? <div>
          <p className='text-lg font-semibold'>All sold out!</p>

          <p className='mt-2.5 text-sm text-grayText'>
            Try adjusting your search by changing your dates or filters.
          </p>
          <div className='fixed bottom-[84px] left-0 -z-[1] flex w-full items-center justify-center px-5 md:hidden'>
            <div className='full rounded-xl border-l-4 border-l-secondary1000 bg-white px-5 py-2.5 shadow-[0_0_12px_rgba(34,34,34,.2)]'>
              <p className='text-sm font-semibold leading-6 '>
                No results found in this area
              </p>
              <p className='text-sm leading-6'>Try broadening your search</p>
            </div>
          </div>
        </div> : <RequestRegionSection />}
    </div>;
};
export default NotFound;